export default __webpack_public_path__ + "static/media/add.b0bcceef.svg";